import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { config } from '../../config';
import type { Coordinates } from '../orderExchange/orderExchange.types';
import type { HereAddress } from './hereAddress.types';

export type Result = {
    items: HereAddress[];
};

// Define a service using a base URL and expected endpoints
export const reverseGeocodeApi = createApi({
    reducerPath: 'reverseGeocodeApi',
    baseQuery: fetchBaseQuery({
        baseUrl: config.backend.HERE_REV_GEOCODING_SERVICE,
    }),
    endpoints: builder => ({
        fetchAddress: builder.query<
            HereAddress,
            { apiKey?: string; coordinates: Coordinates | undefined; language: string }
        >({
            query: ({ apiKey, coordinates, language }) => {
                const at = `at=${coordinates?.latitude},${coordinates?.longitude}`.replace(',', '%2C');
                const lang = `lang=${language}`;
                const limit = 'limit=1';
                const query = [at, lang, limit, `apikey=${apiKey}`].join('&');

                return {
                    url: `?${query}`,
                    responseHandler: async (response: Response) => {
                        const data: Result = await response.json();
                        return data.items.at(0);
                    },
                };
            },
        }),
    }),
});

// Export hooks for usage in function components which are
// auto-generated based on defined endpoints
export const { useFetchAddressQuery } = reverseGeocodeApi;
